import * as React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography, Paper } from '@mui/material';
import { context } from './context';

export const Sidebar = () => {

    const { organizations } = React.useContext(context);
    const params = useParams();
    
    return (
        <Paper 
            elevation={0}
            sx={{ 
                width: '100%', 
                bgcolor: 'background.paper',
                borderRadius: '12px',
                border: '1px solid',
                borderColor: 'divider',
                overflow: 'hidden',
            }}
        >
            <Box sx={{ 
                px: 2.5, 
                py: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}>
                <Typography 
                    variant="subtitle2" 
                    sx={{ 
                        color: 'text.secondary',
                        fontWeight: 600,
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        fontSize: '0.6875rem',
                    }}
                >
                    成员
                </Typography>
            </Box>
            <List 
                sx={{ 
                    p: 1,
                    maxHeight: { xs: '200px', md: 'calc(100vh - 200px)' },
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: 'rgba(0, 0, 0, 0.1)',
                        borderRadius: '2px',
                    },
                }} 
                component='nav'
            >
                { organizations.map(organization => (
                    <ListItem disablePadding key={organization.id} sx={{ mb: 0.5 }}>
                        <ListItemButton 
                            component={RouterLink}
                            to={`/organizations/${organization.id}`}
                            selected={organization.id === parseInt(params.organizationId)}
                            sx={{
                                borderRadius: '8px',
                                py: 1.25,
                                px: 1.5,
                                m: 0,
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    bgcolor: 'rgba(255, 139, 147, 0.06)',
                                },
                                '&.Mui-selected': {
                                    bgcolor: 'rgba(255, 139, 147, 0.1)',
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 139, 147, 0.14)',
                                    },
                                    '& .MuiListItemText-primary': {
                                        color: 'primary.dark',
                                        fontWeight: 600,
                                    },
                                },
                            }}
                        >
                            <ListItemAvatar sx={{ minWidth: 44 }}>
                                <Avatar 
                                    src={`//${organization.avatar}@100w_100h.webp`}
                                    sx={{ 
                                        width: 32, 
                                        height: 32,
                                        border: '2px solid',
                                        borderColor: organization.id === parseInt(params.organizationId) 
                                            ? 'primary.light' 
                                            : 'rgba(0, 0, 0, 0.04)',
                                        boxShadow: 'none',
                                    }}
                                />
                            </ListItemAvatar>
                            <ListItemText 
                                primary={organization.name}
                                primaryTypographyProps={{
                                    variant: 'body2',
                                    sx: { 
                                        fontWeight: 500,
                                        color: 'text.primary',
                                    }
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
}